import React, { useContext, useMemo } from 'react'
import { WidgetContext } from '../widget'
import { useRecoilValue } from 'recoil'
import { Lists } from '../../../utils/lists'
import { subjectUpdateSelector } from '../../../state/subjectUpdate'
import { SubjectUpdate } from '../../../tw/models/SubjectUpdate'
import Group from '../../Card/Group'
import { fi } from '../../../utils/helpers'
import { viewAll } from './utils'
import { HomepageMessages } from './messages'
import WidgetHeader from '../commons/WidgetHeader'
import ViewAllBtn from '../commons/ViewAllBtn'
import { shouldHideButton } from './Homepage'
import NoContent from '../../commons/NoContent'
import styled from '@emotion/styled'

const NoContentElem = styled.div`
	background-color: var(--color-white);
	border: solid 1px var(--color-border-light);
	border-radius: 6px;
`

const HomepageGlobalAnnouncements = () => {
	const context = useContext(WidgetContext)
	const subjectsList = useRecoilValue(subjectUpdateSelector)

	const announcements = useMemo(() => {
		let list = [...Lists.default<SubjectUpdate>(subjectsList)].filter((s) =>
			s.isAnnouncement()
		)
		return Lists.sort(list, 'date', true)
	}, [subjectsList])

	return (
		<div data-testid="global-announcements-widget">
			<WidgetHeader>
				<h2>{HomepageMessages.AnnouncementsWidgetLabel}</h2>
			</WidgetHeader>
			{fi(
				announcements.length,
				<Group items={announcements.slice(0, context.widget.numberOfItems)} />,
				<NoContentElem>
					<NoContent
						label={HomepageMessages.NoGlobalAnnouncements}
						extra={true}
					/>
				</NoContentElem>
			)}
			{!shouldHideButton(context.widget) && (
				<div
					data-testid="global-announcements-view-all"
					className="flex-row-end mr-16"
				>
					<ViewAllBtn
						viewAll={() => viewAll(context.widget)}
						noIcon={true}
						nrOfItems={announcements.length}
					/>
				</div>
			)}
		</div>
	)
}

export default HomepageGlobalAnnouncements
